var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.textColor,attrs:{"href":_vm.url,"target":"_blank"}},[_c('span',{style:({ fontSize: _vm.size + 'px' })},[_vm._t("default")],2),_c('v-icon',{attrs:{"size":_vm.size,"color":_vm.color}},[_vm._v("mdi-open-in-new")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }